import {
  RFQ_CREATE_REQUEST,
  RFQ_CREATE_SUCCESS,
  RFQ_CREATE_FAIL,
  RFQ_CREATE_RESET,
  RFQ_LIST_REQUEST,
  RFQ_LIST_SUCCESS,
  RFQ_LIST_FAIL,
  RFQ_LIST_RESET,
  RFQ_GET_REQUEST,
  RFQ_GET_SUCCESS,
  RFQ_GET_FAIL,
  RFQ_GET_RESET,
  QUOTE_SUBMIT_REQUEST,
  QUOTE_SUBMIT_SUCCESS,
  QUOTE_SUBMIT_FAIL,
  QUOTE_SUBMIT_RESET,
  RFQ_QUOTE_LIST_REQUEST,
  RFQ_QUOTE_LIST_SUCCESS,
  RFQ_QUOTE_LIST_FAIL,
  RFQ_QUOTE_LIST_RESET,
  QUOTE_ACCEPT_REQUEST,
  QUOTE_ACCEPT_SUCCESS,
  QUOTE_ACCEPT_FAIL,
  QUOTE_ACCEPT_RESET,
  LEAD_LIST_REQUEST,
  LEAD_LIST_SUCCESS,
  LEAD_LIST_FAIL,
  LEAD_LIST_RESET,
} from "../Constants/QuoteConstants";

// RFQ CREATE
export const rfqCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case RFQ_CREATE_REQUEST:
      return { loading: true };
    case RFQ_CREATE_SUCCESS:
      return { loading: false, success: true, recordItem: action.payload };
    case RFQ_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case RFQ_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// RFQ LIST
export const rfqListReducer = (
  state = { loading: false, recordItems: [] },
  action
) => {
  switch (action.type) {
    case RFQ_LIST_REQUEST:
      return { loading: true, recordItems: [] };
    case RFQ_LIST_RESET:
      return { recordItems: [] };
    case RFQ_LIST_SUCCESS:
      return {
        loading: false,
        success: true,
        nextStartKey: action.payload.nextStartKey,
        recordItems: action.payload.items,
      };
    case RFQ_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// RFQ GET
export const rfqGetReducer = (
  state = { loading: false, recordItem: {} },
  action
) => {
  switch (action.type) {
    case RFQ_GET_REQUEST:
      return { loading: true, recordItem: {} };
    case RFQ_GET_RESET:
      return { recordItem: {} };
    case RFQ_GET_SUCCESS:
      return {
        loading: false,
        success: true,
        recordItem: action.payload,
      };
    case RFQ_GET_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// QUOTE SUBMIT
export const quoteSubmitReducer = (state = {}, action) => {
  switch (action.type) {
    case QUOTE_SUBMIT_REQUEST:
      return { loading: true };
    case QUOTE_SUBMIT_SUCCESS:
      return { loading: false, success: true, recordItem: action.payload };
    case QUOTE_SUBMIT_FAIL:
      return { loading: false, error: action.payload };
    case QUOTE_SUBMIT_RESET:
      return {};
    default:
      return state;
  }
};

// RFQ QUOTE LIST
export const rfqQuoteListReducer = (
  state = { loading: false, recordItems: [] },
  action
) => {
  switch (action.type) {
    case RFQ_QUOTE_LIST_REQUEST:
      return { loading: true, recordItems: [] };
    case RFQ_QUOTE_LIST_RESET:
      return { recordItems: [] };
    case RFQ_QUOTE_LIST_SUCCESS:
      return {
        loading: false,
        success: true,

        recordItems: action.payload,
      };
    case RFQ_QUOTE_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// QUOTE ACCEPT
export const quoteAcceptReducer = (state = {}, action) => {
  switch (action.type) {
    case QUOTE_ACCEPT_REQUEST:
      return { loading: true };
    case QUOTE_ACCEPT_SUCCESS:
      return { loading: false, success: true, recordItem: action.payload };
    case QUOTE_ACCEPT_FAIL:
      return { loading: false, error: action.payload };
    case QUOTE_ACCEPT_RESET:
      return {};
    default:
      return state;
  }
};

// LEAD LIST
export const leadListReducer = (
  state = { loading: false, recordItems: [] },
  action
) => {
  switch (action.type) {
    case LEAD_LIST_REQUEST:
      return { loading: true, recordItems: [] };
    case LEAD_LIST_RESET:
      return { recordItems: [] };
    case LEAD_LIST_SUCCESS:
      return {
        loading: false,
        success: true,
        nextStartKey: action.payload.nextStartKey,
        recordItems: action.payload.items,
      };
    case LEAD_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
